import Vue from "vue";

window.Vue = require('vue').default;
export const eventbus = new Vue();
